import React from 'react';

import Meta from './../components/Meta';
import useMetaTags from './../hooks/useMetaTags';

import Header from './../components/header';
import Footer from './../components/footer';


import mockupImage from './../assets/mockup.png';
import mockupImage2 from './../assets/mockup2.png';

const features = [
  {
    title: "Live Gold Prices",
    description: "Automatically updates with real-time gold spot prices.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <line x1="12" y1="20" x2="12" y2="10"></line>
  <line x1="18" y1="20" x2="18" y2="4"></line>
  <line x1="6" y1="20" x2="6" y2="16"></line>
  <path d="M22 20H2"></path>
</svg>
    )
  },
  {
    title: "Track Your Collection",
    description: "Add gold coins, bars, jewelry, and more.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <circle cx="12" cy="12" r="3"></circle>
</svg>
    )
  },
  {
    title: "Insights",
    description: "View weight, purity, acquisition cost, and market value.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
  <polyline points="2 17 12 22 22 17"></polyline>
  <polyline points="2 12 12 17 22 12"></polyline>
</svg>
    )
  },
  {
    title: "Portfolio Valuation",
    description: "See total worth, profit\/loss, and investment returns.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
</svg>
    )
  },
  {
    title: "Secure & Private",
    description: "Your data stays on your device.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
</svg>
    )
  },
  {
    title: "Multi-Currency",
    description: "Track your gold collection in multiple international currencies.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <circle cx="12" cy="12" r="10"></circle>
  <line x1="12" y1="6" x2="12" y2="18"></line>
  <path d="M8 10a4 4 0 0 1 8 0"></path>
  <path d="M8 14a4 4 0 0 0 8 0"></path>
</svg>
    )
  }
];



function Home() {
  useMetaTags();
  return (
    <div className="min-h-screen flex flex-col bg-gold-gradient-135">
      <Header />
      <main className="flex-grow">
        {/* Hero Section */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Track & Value Your Gold Collection in Real-Time</h1>
              <p className="text-xl text-gray-600 mb-8">AuLedger is the perfect companion for gold collectors, helping you track, value, and manage your coins, bullion, and jewelry with real-time market insights.</p>
              
              <a 
                href="https://apps.apple.com/us/app/auledger/id6742725527" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 rounded-lg bg-black text-white hover:bg-gray-800 transition-colors"
              >
                <svg className="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.33-3.14-2.57C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                Download on the App Store
              </a>
            </div>
            <div className="md:w-1/2">
              <div className="relative flex justify-center">
                {/* First Phone */}
                <div className="relative" style={{ maxWidth: '300px', zIndex: 10, top: 20}}>
                  <img 
                    src={mockupImage} 
                    alt="App screenshot" 
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Second Phone */}
                <div className="relative -ml-16" style={{ maxWidth: '300px', zIndex: 5, marginTop: 0 }}>
                  <img 
                    src={mockupImage2} 
                    alt="App screenshot 2" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            

            </div>
          </div>
        </div>
      </section>

{/* Features Section */}
<section id="features" className="py-16 bg-gray-100">
  <div className="container mx-auto px-4">
    <h2 className="text-3xl font-bold text-center mb-12">AuLedger Features</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {features.map((feature, index) => (
        <div key={index} className="bg-white p-6 rounded-lg shadow-md">
          <div className="w-12 h-12 bg-gold-50 rounded-full mb-4 flex items-center justify-center text-white">
            {feature.icon}
          </div>
          <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
          <p className="text-gray-600">{feature.description}</p>
        </div>
      ))}
    </div>
  </div>
</section>

{/* Pricing Section */}
<section id="pricing" className="py-16 bg-white">
  <div className="container mx-auto px-4">
    <h2 className="text-3xl font-bold text-center mb-12">Simple Pricing</h2>
    
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Free Plan */}
      <div className="border rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
        <div className="p-6 bg-gray-50">
          <h3 className="text-2xl font-bold mb-2">Free</h3>
          <p className="text-gray-600 mb-4">Perfect for casual collectors</p>
          <p className="text-4xl font-bold">$0</p>
          <p className="text-gray-500">Forever</p>
        </div>
        <div className="p-6">
          <ul className="space-y-3">
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Add your entire collection
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Track value in USD
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Basic collection insights
            </li>
          </ul>
        </div>
      </div>
      
      {/* Premium Plan */}
      <div className="border rounded-lg overflow-hidden shadow-lg border-gold-50">
        <div className="p-6 bg-gold-50">
          <h3 className="text-2xl font-bold mb-2 text-black">Premium</h3>
          <p className="text-black mb-4">For serious collectors</p>
          <p className="text-4xl font-bold text-black">$1.99</p>
          <p className="text-black">per month</p>
        </div>
        <div className="p-6">
          <ul className="space-y-3">
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Everything in Free
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Daily gold prices
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              YTD gold price trends
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Multi-currency support
            </li>
            <li className="flex items-center">
              <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Ad-free experience
            </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div className="mt-12 text-center">
      <p className="text-gray-600 max-w-2xl mx-auto">
        AuLedger helps you track and manage your gold collection with ease. Our free plan gives you 
        the essentials, while Premium unlocks the full experience for serious collectors.
      </p>
    </div>
  </div>
</section>

      {/* Call to Action */}
      <section className="py-16 bg-gold-70">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-8">Ready to Get Started?</h2>
          <a 
            href="https://apps.apple.com/us/app/auledger/id6742725527" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 rounded-lg bg-black text-white hover:bg-gray-800 transition-colors text-lg"
          >
            <svg className="w-6 h-6 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.33-3.14-2.57C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            Download on the App Store
          </a>
        </div>
      </section>


{/* Support Section */}
<section id="support" className="py-16 bg-gray-50">
  <div className="container mx-auto px-4">
    <h2 className="text-3xl font-bold text-center mb-8">Support</h2>
    
    <div className="max-w-3xl mx-auto text-center">
      <p className="text-lg mb-6">
        If you have any questions, feedback, or features you'd like to see, 
        we'd love to hear from you!
      </p>
      
      <div className="bg-white rounded-lg shadow-md p-8 mb-8">
        <svg className="h-12 w-12 text-gold-50 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
        </svg>
        
        <p className="text-xl font-semibold mb-2">Contact us at:</p>
        <a href="mailto:contact@auledgerapp.com" className="text-xl text-gold-50 hover:underline">
          contact@auledgerapp.com
        </a>
      </div>
      
      <p className="text-gray-600">
        Our team is committed to providing you with the best experience possible. 
        We typically respond to inquiries within 24 hours.
      </p>
    </div>
  </div>
</section>
      </main>
      <Footer />
    </div>
  );
}

export default Home;